module.exports = __webpack_public_path__ + "credito-15-d-x1C.png";